import { mountClassic } from '../render/classic/classic-app.js';
import { tripeaksClassicSpec } from '../variants/tripeaks/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(tripeaksClassicSpec, { root, title: 'TriPeaks' });
